export let FilterType = /*#__PURE__*/function (FilterType) {
  FilterType["Status"] = "status";
  FilterType["SentBy"] = "sentBy";
  FilterType["SentDate"] = "sentDate";
  FilterType["CompanyName"] = "companyName";
  FilterType["ApprovalDate"] = "approvalDate";
  FilterType["AgreementName"] = "agreementName";
  return FilterType;
}({});
export const filterLabels = {
  [FilterType.Status]: 'Status',
  [FilterType.SentBy]: 'Sent by',
  [FilterType.SentDate]: 'Sent date',
  [FilterType.CompanyName]: 'Company name',
  [FilterType.ApprovalDate]: 'Approval date',
  [FilterType.AgreementName]: 'Agreement name'
};
export let ProposalReportEntryStatus = /*#__PURE__*/function (ProposalReportEntryStatus) {
  ProposalReportEntryStatus["All"] = "all";
  ProposalReportEntryStatus["NotReviewed"] = "notReviewed";
  ProposalReportEntryStatus["Reviewed"] = "reviewed";
  ProposalReportEntryStatus["Signed"] = "signed";
  ProposalReportEntryStatus["Expired"] = "expired";
  ProposalReportEntryStatus["Withdrawn"] = "withdrawn";
  ProposalReportEntryStatus["Terminated"] = "terminated";
  return ProposalReportEntryStatus;
}({});